export const ROLES = {
    ADMIN: 'admin',
    OWNER: 'user_owner',
    SIMPLE: 'user_simple',
  };

  // Types de Device pouvant être utilisés comme "actuateur" dans une association
  // (le côté qu'on allume/éteint) — doit rester aligné avec backend/src/utils/constants.js
  export const ACTUATOR_TYPES = ['switch', 'ir_controller'];
  
  export const COLORS = {
    blueLight: '#E6F4FF',
    bluePrimary: '#1E88E5',
    blueDark: '#0D47A1',
  };